import { render, staticRenderFns } from "./carmonthRuleForm.vue?vue&type=template&id=d96e0d78&scoped=true&"
import script from "./carmonthRuleForm.vue?vue&type=script&lang=js&"
export * from "./carmonthRuleForm.vue?vue&type=script&lang=js&"
import style0 from "./carmonthRuleForm.vue?vue&type=style&index=0&id=d96e0d78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96e0d78",
  null
  
)

export default component.exports